<template>
    <div>
       <span v-if="showTime.D > 0">{{showTime.D}}天</span>
       <span>{{showTime.H}}:</span>
       <span>{{showTime.M}}:</span>
       <span>{{showTime.S}}</span>
    </div>
</template>

<script>
export default {
    props: {
        time: {
            type: String
        }
    },
    data() {
        return {
            interval:null,
            showTime: {
                D: 0,
				H: 0,
				M: 0,
				S: 0
			}, //倒计时
        }
    },
    mounted() {
        this.showTimes()
    },
    methods: {
        showTimes() {
            console.log(12312321)
			let that = this;
			this.interval = setInterval(() => {
                let nowTime = new Date().getTime();
				let startDate = that.time
				// let startDate = "2021-10-31 16:42:33"
				// startDate = startDate.replace(new RegExp('-', 'gm'), '/');
				let startDateM = new Date(startDate).getTime(); //得到毫秒数
				let lefttime = startDateM - nowTime;
				if (lefttime > 0) {
                    that.$set(this.showTime, 'D', Math.floor(lefttime / (1000 * 60 * 60 * 24)) )
                    that.$set(this.showTime, 'H', Math.floor(lefttime / (1000 * 60 * 60)) - (that.showTime.D * 24))
                    that.$set(this.showTime, 'M', Math.floor((lefttime / (1000 * 60)) % 60))
                    that.$set(this.showTime, 'S',  Math.floor((lefttime / 1000) % 60) )
				} else {
					that.showTime.D = '00';
					that.showTime.H = '00';
					that.showTime.M = '00';
					that.showTime.S = '00';
					clearInterval(this.interval);
				}
			}, 1000);
		}
    }
}
</script>